import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {CommissionImportRow} from '../../../shared/interface/commission-import-row';
import {ReplaySubject, forkJoin, Subject} from 'rxjs';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {CommissionImportRowService} from '../../../shared/services/commission-import-row.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../../../shared/services/auth.service';
import {FilterService} from '../../../shared/services/filter.service';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {StoreRootState} from '../../../shared/ngrx/reducers';
import {delay, distinctUntilChanged, first, takeUntil, finalize} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {getCurrentRouteState} from '../../../shared/ngrx/selector';
import {RouterStateUrl} from '../../../shared/ngrx/route-serializer';
import {Sort} from '@angular/material/sort';
import {Uuid} from '../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../shared/components/job-result-dialog/job-result-dialog.component';
import {MassEditionDialogComponent} from '../mass-edition-dialog/mass-edition-dialog.component';
import {
  COMMISSION_IMPORT_ROW_STATUS,
  COMMISSION_IMPORT_ROW_STATUS_ASSIGNED, COMMISSION_IMPORT_ROW_STATUS_NEW, COMMISSION_IMPORT_ROW_STATUS_REJECTED,
  DictService, RATE_THRESHOLD_10, RATE_THRESHOLD_40,
} from '../../../shared/services/dict.service';
import moment from "moment/moment";


@Component({
  selector: 'app-mass-edition',
  templateUrl: './mass-edition.component.html',
  styleUrls: ['./mass-edition.component.scss']
})
export class MassEditionComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() commissionRedirection: string = null;
  @Input() commissionSettlement: string = null;
  @Input() embeddedView = false;
  @Input() enableFilters?: string[] = null;
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  readonly COMMISSION_IMPORT_ROW_STATUS_ASSIGNED = COMMISSION_IMPORT_ROW_STATUS_ASSIGNED;

  readonly RATE_THRESHOLD_40 = RATE_THRESHOLD_40;
  readonly RATE_THRESHOLD_10 = RATE_THRESHOLD_10;

  initialFilters: any;
  massEditDisabled = true;
  rows: CommissionImportRow[] = [];
  displayedColumns: string[] = [
    'insuranceCompany', 'partner', 'ofwca', 'policyNumber', 'collection', 'rate', 'commission',
    'internalRisk', 'riskPack', 'riskCode', 'policyType', 'statusChange', 'status',
  ];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  selectedInsuranceCompanies: InsuranceCompany[] = [];
  sortBy: string | null = null;
  sortOrder: 'asc' | 'desc' | null = null;
  loadingData = true;
  statusId: number = null;
  statusIdReject = false;
  statusIdNew = false;
  billingMonth: any = null;
  billingMonthCurrent = false;
  date: any = null;
  massFilter: any;

  private statusNewDictId?: number;
  private statusRejectedDictId?: number;

  private destroyed$ = new Subject<void>();

  constructor(
    private commissionImportRowService: CommissionImportRowService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
    private dictService: DictService
  ) {
    this.userPermissions = auth.getUserPermissions();

    // this.commissionImportRowService.rowListSubject
    //   .pipe(
    //     takeUntil(this.destroyed$),
    //     delay(0)
    //   ).subscribe({
    //   next: (response: CountedAndPaginated<CommissionImportRow>) => {
    //     this.loadingData = false;
    //     this.rows = response.items;
    //     this.totalData = response.pagination.total;
    //   },
    //   error: (response: HttpErrorResponse) => {
    //     this.snack.open('Przy ładowaniu danych wystąpił błąd', response.status.toString(), {duration: 2000});
    //     this.loadingData = false;
    //   }
    // });

    this.parseFilters();
    this.date = moment();
    this.date.startOf('month');
    this.date.subtract(1, 'month');
    // this.initialFilters.billingMonth = date;
    // this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
    //   billingMonth: this.initialFilters.billingMonth,
    //   ...this.initialFilters,
    // })]);

  }

  parseFilters(filters?: any): void {

    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      in$insuranceCompany: 'int[]',
      containsFromLeft$policyNumber: 'string',
      company: 'int',
      ofwca: 'string',
      partner: 'string',
      parentPartner: 'string',
      gte$collection: 'string',
      lte$collection: 'string',
      partnerAssetsRegional: 'string',
      ofwcaAssetsRegional: 'string',
      notMatched: 'string[]',
      matched: 'string[]',
      contract: 'string',
      importer: 'int[]',
      gte$createdAt: 'string',
      lte$createdAt: 'string',
      risk: 'int',
      in$status: 'int[]',
      billingMonth: 'date',
      contains$riskPack: 'string',
      contains$riskCode: 'string',
      contains$customerName: 'string',
      gte$rate: 'string',
      lte$rate: 'string',
      gte$ratePaid: 'string',
      lte$ratePaid: 'string',
      gte$commissionPaid: 'string',
      lte$commissionPaid: 'string',
      gte$importCommission: 'string',
      lte$importCommission: 'string',
      policyType: 'int',
      identifier: 'string',
      overvoltage: 'int',
      rejectedCommission: 'int',
      annex: 'int',
      contractOwnerError: 'int',
      settlementIs: 'int',
      overvoltagePolicy: 'int',
      edition: 'int',
      contractOwner: 'int',
      overcommissionPartner: 'string',

    }, filters);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // this.dictService.getId(COMMISSION_IMPORT_ROW_STATUS_NEW, COMMISSION_IMPORT_ROW_STATUS)
    //   .pipe()
    //   .subscribe((dictId: number) => {
    //     this.statusIdNew = dictId;
    //   });
    this.activatedRoute.data.pipe(first()).subscribe((data: any) => {
      this.statusIdNew = data.statusKey === 'new';
      this.statusIdReject = data.statusKey === 'reject';
      this.billingMonthCurrent = data.billingMonth === 'current';
    });

    forkJoin({
      newId: this.dictService.getId(COMMISSION_IMPORT_ROW_STATUS_NEW, COMMISSION_IMPORT_ROW_STATUS).pipe(first()),
      rejectedId: this.dictService.getId(COMMISSION_IMPORT_ROW_STATUS_REJECTED, COMMISSION_IMPORT_ROW_STATUS).pipe(first()),
    }).pipe(first()).subscribe(({newId, rejectedId}) => {
      this.statusNewDictId = newId;
      this.statusRejectedDictId = rejectedId;

      // dopiero po preloadzie słowników możemy bezpiecznie reagować na paginator/store
      this.initPagingAndRouting();
    });

    // this.paginator.page
    //   .pipe(
    //     takeUntil(this.destroyed$)
    //   ).subscribe((event: PageEvent) => {
    //   this.loadingData = true;
    //   if (this.embeddedView) {
    //     this.loadListData();
    //   } else {
    //     this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
    //       page: event.pageIndex,
    //       pageSize: event.pageSize,
    //       sortBy: this.sortBy,
    //       sortOrder: this.sortOrder,
    //       ...this.filtersForm.value
    //     })]);
    //   }
    // });
    //
    // if (!this.embeddedView) {
    //   this.store
    //     .pipe(
    //       select(getCurrentRouteState),
    //       delay(0),
    //       distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
    //       takeUntil(this.destroyed$),
    //     )
    //     .subscribe((state: RouterStateUrl) => {
    //       this.parseFilters(state.params);
    //       this.paginator.pageIndex = state.params.page;
    //       this.paginator.pageSize = state.params.pageSize;
    //       this.sortBy = state.params?.sortBy ? state.params.sortBy : 'createdAt';
    //       this.sortOrder = state.params?.sortOrder ? state.params.sortOrder : 'desc';
    //       this.loadListData();
    //     })
    //   ;
    // } else {
    //   this.loadListData();
    // }
  }


  sortChanged($event: Sort): void {
    this.sortBy = $event.active;
    this.sortOrder = $event.direction || 'desc';

    if (!this.embeddedView) {
      const params: any = this.filterService.parseFiltersToQueryParams({
        page: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value
      });
      if (this.sortBy && this.sortOrder) {
        params.sortBy = this.sortBy;
        params.sortOrder = this.sortOrder;
      }
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, params]);
    } else {
      this.loadListData();
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (this.statusIdNew && this.statusNewDictId != null) {
      this.initialFilters.in$status = [this.statusNewDictId];
      filters.in$status = [this.statusNewDictId];
    }

    if (this.statusIdReject && this.statusRejectedDictId != null) {
      this.initialFilters.in$status = [this.statusRejectedDictId];
      filters.in$status = [this.statusRejectedDictId];
    }

    if (this.billingMonthCurrent) {
      this.initialFilters.billingMonth = this.date;
      filters.billingMonth = this.date;
    }

    if (this.commissionRedirection != null) {
      filters.commissionRedirection = this.commissionRedirection;
    }

    if (this.commissionSettlement != null) {
      filters.settlement = this.commissionSettlement;
    }

    return filters;
  }

  loadListData(): void {
    this.loadingData = true;

    this.commissionImportRowService.loadMassEditionList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters(),
      this.sortBy && this.sortOrder ? {sortBy: this.sortBy, sortOrder: this.sortOrder} : undefined
    )
      .pipe(takeUntil(this.destroyed$), finalize(() => this.loadingData = false))
      .subscribe({
        next: (response) => {
          this.rows = response.items;
          this.totalData = response.pagination.total;
        },
        error: (error: HttpErrorResponse) => {
          this.snack.open('Przy ładowaniu danych wystąpił błąd', error.status.toString(), {duration: 2000});
        }
      });

  }

  filter(): void {
    if (this.loadingData) {
      return;
    }
    this.massEditDisabled = true;
    this.statusId = null;
    this.billingMonth = null;
    if (this.embeddedView) {
      if (this.paginator.pageIndex === 0) {
        this.loadListData();
      } else {
        this.paginator.firstPage();
      }
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        sortBy: this.sortBy || null,
        sortOrder: this.sortOrder || null,
        ...this.filtersForm.value,
      })]);
      this.massFilter = this.filtersForm.value;


    }
    if (!this.loadingData) {
      this.massEditDisabled = false;
    }
  }

  downloadReport(): void {
    this.commissionImportRowService.downloadReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.massEditDisabled = true;
    this.filtersForm.resetForm();
    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        page: 0,
        pageSize: this.paginator.pageSize,
      }]);
    }
  }

  massEdit(): void {
    const dialogRef = this.dialog.open(MassEditionDialogComponent, {
      width: '80vw',
      maxHeight: '80vh',
      data: {filters: this.buildFilters(), showProgress: false},
    });

    dialogRef.afterClosed().subscribe(() => this.loadListData());
  }

  onChange(event): void {
    this.massEditDisabled = true;

  }

  removeThresholds(manuallySet: string[]): string[] {
    return manuallySet.filter(
      (item) => item !== RATE_THRESHOLD_40 && item !== RATE_THRESHOLD_10
    );
  }

  showMassEditChips(manuallySet: string[]): boolean {
    const filteredSet = this.removeThresholds(manuallySet);
    return filteredSet.length > 0;
  }


  private initPagingAndRouting(): void {
    if (!this.paginator) {
      return;
    }
    this.paginator.page
      .pipe(takeUntil(this.destroyed$))
      .subscribe((event: PageEvent) => {
        this.loadingData = true;
        if (this.embeddedView) {
          this.loadListData();
        } else {
          this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
            page: event.pageIndex,
            pageSize: event.pageSize,
            sortBy: this.sortBy || null,
            sortOrder: this.sortOrder || null,
            ...this.filtersForm.value
          })]);
        }
      });

    if (!this.embeddedView) {
      this.store.pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      ).subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.sortBy = state.params?.sortBy || null;
        this.sortOrder = state.params?.sortOrder || null;
        this.loadListData();
      });
    } else {
      this.loadListData();
    }
  }
}
